var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerateAccessKey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55263 0C5.13158 0 6.39474 0.947368 6.86842 2.36842H14.2105V4.73684H11.8421V7.10526H9.47368V4.73684H6.86842C6.39474 6.15789 5.05263 7.10526 3.55263 7.10526C1.57895 7.10526 0 5.52632 0 3.55263C0 1.57895 1.57895 0 3.55263 0ZM3.55263 2.36842C2.92105 2.36842 2.36842 2.92105 2.36842 3.55263C2.36842 4.18421 2.92105 4.73684 3.55263 4.73684C4.18421 4.73684 4.73684 4.18421 4.73684 3.55263C4.73684 2.92105 4.18421 2.36842 3.55263 2.36842ZM3.94737 11.0526H6.31579V8.68421H7.89474V11.0526H10.2632V12.6316H7.89474V15H6.31579V12.6316H3.94737V11.0526Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateAccessKey);
export default __webpack_public_path__ + "static/media/generate_access_key.84c70f6628d1016baaf53a26d88503ac.svg";
export { ForwardRef as ReactComponent };